import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Get all deleted items from recycle bin
export const getRecycleBinItems = async (filters = {}) => {
  try {
    const response = await axios.get(`${API_URL}/recycle-bin`, {
      ...getAuthHeaders(),
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch recycle bin items' };
  }
};

// Get single deleted item by ID
export const getRecycleBinItem = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/recycle-bin/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch item details' };
  }
};

// Get restoration plan for an item
export const getRestorationPlan = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/recycle-bin/${id}/restoration-plan`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch restoration plan' };
  }
};

// Check restoration conflicts
export const checkRestorationConflicts = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/recycle-bin/${id}/conflicts`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to check conflicts' };
  }
};

// Restore item from recycle bin
export const restoreItem = async (id, data) => {
  try {
    const response = await axios.post(`${API_URL}/recycle-bin/${id}/restore`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to restore item' };
  }
};

// Permanently delete item
export const permanentDelete = async (id, reason) => {
  try {
    const response = await axios.delete(`${API_URL}/recycle-bin/${id}/permanent`, {
      ...getAuthHeaders(),
      data: { 
        confirmation: 'PERMANENTLY DELETE',
        deletion_reason: reason 
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to permanently delete item' };
  }
};

// Get recycle bin statistics
export const getRecycleBinStats = async (filters = {}) => {
  try {
    const response = await axios.get(`${API_URL}/recycle-bin/statistics`, {
      ...getAuthHeaders(),
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to fetch statistics' };
  }
};

// Empty recycle bin
export const emptyRecycleBin = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/recycle-bin/empty`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to empty recycle bin' };
  }
};
